var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import RelatedBusinessesCard from './RelatedBusinessesCard.vue';
let RelatedBusinessesModal = class RelatedBusinessesModal extends Vue {
    get show() {
        return this.value;
    }
    set show(val) {
        this.$emit('input', val);
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], RelatedBusinessesModal.prototype, "value", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], RelatedBusinessesModal.prototype, "businesses", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], RelatedBusinessesModal.prototype, "isLoading", void 0);
__decorate([
    Prop({ type: String, default: '' })
], RelatedBusinessesModal.prototype, "searchId", void 0);
RelatedBusinessesModal = __decorate([
    Component({
        components: {
            RelatedBusinessesCard,
        },
    })
], RelatedBusinessesModal);
export default RelatedBusinessesModal;
